<template>
  <div class="auth-illustration">
    <!-- Gradient ellipses as fallback background -->
    <div class="gradient-container">
      <div class="ellipse ellipse-1"></div>
      <div class="ellipse ellipse-2"></div>
      <div class="ellipse ellipse-3"></div>
      <div class="ellipse ellipse-4"></div>
      <div class="ellipse ellipse-5"></div>
    </div>

    <!-- Background image -->
    <img src="@/assets/illustrations/auth/auth-illustration.png" class="background-image" alt="" />

    <!-- Grid overlay -->
    <div class="grid-overlay"></div>

    <!-- Content at bottom -->
    <div class="content-container">
      <img src="@/assets/illustrations/auth/anima-logo.svg" class="anima-logo" alt="Anima" />
      <div class="text-container">
        <p class="title">AI with an eye for design</p>
        <p class="description">Use our templates as a starting point and turn it into your own product by prompting.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthIllustration'
};
</script>

<style lang="scss" scoped>
.auth-illustration {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 80px 0;
  background-color: var(--primitive-colors-purple-dark-purple-190, #1a0d2e);
}

.gradient-container {
  position: absolute;
  width: 200%;
  height: 200%;
  top: -50%;
  left: -50%;
  z-index: 0;
}

.ellipse {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.8;
}

.ellipse-1 {
  width: 1000px;
  height: 1150px;
  background: var(--auth-illustration-bg);
  top: 10%;
  left: 5%;
}

.ellipse-2 {
  width: 1000px;
  height: 1150px;
  background: var(--auth-illustration-bg);
  top: 25%;
  left: -5%;
}

.ellipse-3 {
  width: 950px;
  height: 1100px;
  background: radial-gradient(circle, var(--blue) 0%, transparent 70%);
  mix-blend-mode: hard-light;
  top: 30%;
  left: 0%;
}

.ellipse-4 {
  width: 1000px;
  height: 1150px;
  background: radial-gradient(circle, var(--purple-primary) 0%, transparent 70%);
  top: 40%;
  left: 5%;
}

.ellipse-5 {
  width: 1000px;
  height: 1150px;
  background: radial-gradient(circle, var(--purple-primary-50) 0%, transparent 70%);
  top: 55%;
  left: -5%;
}

.background-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}

.content-container {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  position: relative;
  z-index: 3;
  flex: 0 0 auto;
}

.anima-logo {
  width: 58px;
  height: auto;
  position: relative;
  flex: 0 0 auto;
}

.text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  position: relative;
  flex: 0 0 auto;
}

.title {
  position: relative;
  color: #fff;
  text-align: center;
  font-family: 'Roslindale Display Condensed', 'Roslindale Deck', Helvetica, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  margin: 0;
  white-space: nowrap;
}

.description {
  position: relative;
  font-family: 'Mulish', Helvetica, sans-serif;
  font-weight: 400;
  color: var(--primitive-colors-neutrals-transparent-light-50, rgba(255, 255, 255, 0.5));
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
  margin: 0;
  max-width: 320px;
}

.grid-overlay {
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(
      0deg,
      transparent,
      transparent 100px,
      color-mix(in srgb, var(--purple-primary) 5%, transparent) 100px,
      color-mix(in srgb, var(--purple-primary) 5%, transparent) 101px
    ),
    repeating-linear-gradient(
      90deg,
      transparent,
      transparent 100px,
      color-mix(in srgb, var(--purple-primary) 5%, transparent) 100px,
      color-mix(in srgb, var(--purple-primary) 5%, transparent) 101px
    );
  mix-blend-mode: overlay;
  opacity: 0.3;
  z-index: 2;
}
</style>
